import type { FC, ReactNode } from 'react'

import { useEffect, useState } from 'react'

import { cn } from '@/lib/utils'

const ROWS: { label: string; value: string; href?: string }[] = [
    { label: 'Email', value: 'hello@reverie.studio', href: 'mailto:hello@reverie.studio' },
    { label: 'Studio', value: 'by appointment, at dawn' },
    { label: 'Elsewhere', value: '@reverie.imagined' },
    { label: 'Prints', value: 'editions of eleven' }
]

const value =
    'font-editorial block text-[color:var(--rev-ink)] transition-all duration-700 ease-[cubic-bezier(0.16,1,0.3,1)] md:translate-x-2 md:opacity-0 md:blur-[5px] md:group-hover:translate-x-0 md:group-hover:opacity-100 md:group-hover:blur-[0px] md:group-focus-within:translate-x-0 md:group-focus-within:opacity-100 md:group-focus-within:blur-[0px]'

/**
 * The index withholds itself on pointer devices: each line resolves only when
 * you reach for it. Small screens and keyboard focus always show everything.
 */
export const ContactIndex: FC = (): ReactNode => {
    const [hour, setHour] = useState('')

    useEffect(() => {
        const write = (): void => {
            const now = new Date()

            setHour(
                `${String(now.getHours()).padStart(2, '0')}:${String(now.getMinutes()).padStart(2, '0')}`
            )
        }

        write()

        const id = window.setInterval(write, 20_000)

        return (): void => window.clearInterval(id)
    }, [])

    return (
        <div>
            <span className='rev-eyebrow block text-[color:var(--rev-ink-faint)]'>
                The index
            </span>

            <dl className='mt-[26px]'>
                {ROWS.map(row => (
                    <div
                        key={row.label}
                        className='group border-t border-[var(--rev-hairline-soft)] py-[15px] transition-colors duration-500 hover:border-[var(--rev-hairline)] focus-within:border-[var(--rev-hairline)]'
                    >
                        <dt className='rev-mark text-[color:var(--rev-ink-faint)]'>
                            {row.label}
                        </dt>

                        <dd className='rev-note mt-[8px]'>
                            {row.href ? (
                                <a href={row.href} className={cn(value, 'underline-offset-[5px] hover:underline')}>
                                    {row.value}
                                </a>
                            ) : (
                                <span className={value}>{row.value}</span>
                            )}
                        </dd>
                    </div>
                ))}
            </dl>

            <div className='mt-[clamp(38px,7vh,72px)]'>
                <span className='rev-mark block text-[color:var(--rev-ink-faint)]'>
                    The hour where you are
                </span>

                <p
                    className='font-display mt-[10px] tabular-nums text-[color:var(--rev-ink)]'
                    style={{
                        fontSize: 'clamp(30px, 4.4vw, 52px)',
                        fontWeight: 500,
                        letterSpacing: '-0.02em',
                        lineHeight: 1
                    }}
                >
                    {hour || '—'}
                </p>

                <span className='rev-note mt-[10px] block text-[color:var(--rev-ink-faint)]'>
                    the hour that never rose
                </span>
            </div>
        </div>
    )
}
